/**
 * Cheelee Public API Docs
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CurrencyPairItem } from '@api/exchange-rates';


export interface CurrencyPair {
  data: {
    items: CurrencyPairItem[]
  }
}

